module.exports = __webpack_public_path__ + "img/372.ca0d2f9c.png";